module.exports = __webpack_public_path__ + "img/it_it_day-18.101923cb.svg";